import { useMemo } from 'react';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { INLINE_LABEL_TYPES } from 'reporting-ui-components/components/inlineLabels/utils';
import { reportConfigProcessor } from '../../../insights/utils';
import useConfigSummaryKpiReports from './useConfigSummaryKpiReports';
import { jsx as _jsx } from "react/jsx-runtime";
const PREVIEW_KPI_LIMIT = 1;
const ConfigReportKPIPreview = ({
  report,
  NoSummaryComponent
}) => {
  const processedReport = useMemo(() => {
    return reportConfigProcessor(report);
  }, [report]);
  const gatedSummaryReports = useConfigSummaryKpiReports(processedReport, PREVIEW_KPI_LIMIT);
  const summaryReport = gatedSummaryReports.length > 0 ? gatedSummaryReports[0] : null;
  return summaryReport ? /*#__PURE__*/_jsx(PlatformReportResolver, {
    allowDrilldown: false,
    report: summaryReport,
    inlineLabelTypes: [INLINE_LABEL_TYPES.DATE]
  }) : /*#__PURE__*/_jsx(NoSummaryComponent, {});
};
export default ConfigReportKPIPreview;